module.exports = __webpack_public_path__ + "img/symbol_0.8a34c888.png";